"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HrOptions = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Input_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Input");
const Slider_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Slider");
const Separator_1 = require("@jsonjoy.com/ui/lib/3-list-item/Separator");
const FormRow_1 = require("@jsonjoy.com/ui/lib/3-list-item/FormRow");
const Tabs_1 = require("@jsonjoy.com/ui/lib/3-list-item/Tabs");
const LineStyleTab_1 = require("../LineStyleTab");
const state_1 = require("./state");
const settings = tslib_1.__importStar(require("./settings"));
const use_t_1 = require("use-t");
const blockClass = (0, nano_theme_1.rule)({
    bxz: 'border-box',
    d: 'flex',
    fld: 'column',
    gap: '12px',
    maxW: '500px',
});
const STYLE_LABELS = {
    solid: 'Line',
    dashed: 'Dashed',
    dotted: 'Dotted',
    squiggly: 'Squiggly',
};
const stopInputKeyDown = (event) => {
    event.stopPropagation();
};
const styleTabs = settings.HR_LINE_STYLES.map((style) => ({
    key: style,
    label: React.createElement(LineStyleTab_1.LineStyleTabLabel, { style: style, label: STYLE_LABELS[style] }),
}));
const HrOptions = () => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, state_1.useHrOptionsState)();
    const strokeWidth = state.strokeWidth.use();
    const lineWidth = state.lineWidth.use();
    const lineStyle = state.lineStyle.use();
    const blockHeight = state.blockHeight.use();
    const caption = state.caption.use();
    const handleStyleChange = React.useCallback((key) => state.setLineStyle(key), [state]);
    return (React.createElement("div", { className: blockClass },
        React.createElement(Input_1.Input, { type: "text", value: caption, label: t('Caption (optional)'), placeholder: t('Between the lines'), onChange: state.setCaption, onKeyDown: stopInputKeyDown, onEnter: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.apply();
            }, onEsc: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.cancel();
            } }),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: t('Line style'), descriptionAbove: true, description: t('Choose how the line is drawn.') },
            React.createElement(Tabs_1.Tabs, { items: styleTabs, active: lineStyle, onChange: handleStyleChange })),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: t('Line stroke'), descriptionAbove: true, description: t('Thickness of the line in pixels.') },
            React.createElement(Slider_1.Slider, { value: strokeWidth, min: settings.HR_STROKE_WIDTH_MIN, max: settings.HR_STROKE_WIDTH_MAX, step: 1, showValue: true, onChange: state.setStrokeWidth })),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: t('Line width'), descriptionAbove: true, description: t('Horizontal extent of the line as a percentage.') },
            React.createElement(Slider_1.Slider, { value: lineWidth, min: settings.HR_LINE_WIDTH_MIN, max: settings.HR_LINE_WIDTH_MAX, step: 1, showValue: true, onChange: state.setLineWidth })),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: t('Block height'), descriptionAbove: true, description: t('Vertical space taken by the separator.') },
            React.createElement(Slider_1.Slider, { value: blockHeight, min: settings.HR_BLOCK_HEIGHT_MIN, max: settings.HR_BLOCK_HEIGHT_MAX, step: 1, showValue: true, onChange: state.setBlockHeight }))));
};
exports.HrOptions = HrOptions;
